export const DELETE_REQUEST = 'DELETE_REQUEST';
export const EXPORT_REQUEST = 'EXPORT_REQUEST';
export const ALL_REQUEST_TYPES = [DELETE_REQUEST, EXPORT_REQUEST];
export const REQUEST_TYPES_MAP = {
  DELETE_REQUEST,
  EXPORT_REQUEST
};